import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { Box, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Logo } from '.';
import { usePathname } from '../../hooks/usePathname';

gsap.registerEffect({
  name: "textAnimation",
  defaults: { duration: 2 },
  effect: (targets, config) => {
    return gsap
      .timeline()
      .from(
        targets,
        {
          duration: 0.5,
          opacity: 0,
          scale: 0,
          y: 80,
          rotationX: 180,
          transformOrigin: "0% 50% -50",
          ease: "back",
          stagger: 0.01,
          delay: config.delay / 25
        },
        "+=0"
      );
  }
});


const LogoLaborAnimation = () => {
  const navigator = useNavigate();
  const pathname = usePathname();

  const ele = useRef(null);

  const handleLink = () => {
    if(['/honhai/lauan/app'].includes(pathname)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    navigator('/honhai/lauan/app');
  }

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo('.Sim-site-name .Sim-site-word', {
          x: 50,
          opacity: 0,
        },
        {
          delay: 0, // 0秒後
          duration: 1, // 1秒間
          x: 0,
          opacity: 1,
          ease: 'power2.easeOut',
          stagger: {
            from: 'start', // 左側
            amount: 0.5, // 0.5秒
          },
        })
    }, ele);
    return () => ctx.revert();
  }, [])
  return (
    <Stack
      direction='row'
      alignItems='center'
      spacing={1.5}
      sx={{ mr: 1, color: 'text.primary', textDecoration: 'auto', cursor: 'pointer' }}
      onClick={() => handleLink()}
    >
      {/* <Logo disabledLink /> */}

      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="32" viewBox="0 0 30 32" fill="none">
        <g clipPath="url(#clip0_10012_3203)">
        <path d="M14.7478 32L14.108 31.7395C0.763211 26.3422 0.0274207 17.627 0 17.2614V17.1562V5.30591L0.191945 4.94944C0.466153 4.43759 3.20823 0 14.7067 0C26.2051 0 28.9472 4.43759 29.2214 4.94487L29.4133 5.30134V12.5541C29.4133 13.4362 28.6958 14.1537 27.8138 14.1537C26.9317 14.1537 26.2142 13.4362 26.2142 12.5541V6.25193C25.4693 5.47044 22.6267 3.19909 14.7067 3.19909C6.78663 3.19909 3.90289 5.48872 3.19909 6.23822V17.0831C3.26307 17.6727 4.20908 24.048 14.6701 28.513C25.5424 23.3853 25.9857 19.2356 26.2234 16.9871C26.3148 16.1097 27.1054 15.4744 27.9829 15.5658C28.8603 15.6572 29.5001 16.4479 29.4042 17.3253C28.9426 21.6761 26.9272 26.429 15.3739 31.7167L14.7478 32.0046V32Z" fill="white"/>
        <path d="M6.24264 15.0677C6.19694 15.1179 6.17866 15.1865 6.19237 15.2551L6.54884 17.0283L4.41459 16.5255L4.40088 13.0888L6.51685 12.4901C6.56712 12.4764 6.61739 12.4399 6.64481 12.3942L8.31747 9.78918L10.502 11.896C9.96729 12.7323 9.65652 13.7332 9.65652 14.798C9.65652 14.8575 9.65652 14.9214 9.66109 14.9808H6.4163C6.34775 14.9808 6.28377 15.0128 6.24264 15.0677Z" fill="white"/>
        <path d="M16.9138 22.6541L16.498 24.5735L13.0612 24.6512L12.4214 22.5444C12.4077 22.4896 12.3711 22.4439 12.3254 22.4164L9.68848 20.7895L11.4937 18.8563C12.4443 19.6972 13.6919 20.2045 15.0629 20.2045H15.1086L15.1543 22.7592C15.1543 22.8278 15.1863 22.8917 15.2412 22.9329C15.2914 22.9786 15.3646 22.9923 15.4286 22.9786L16.9138 22.6541Z" fill="white"/>
        <path d="M24.8663 13.0614L24.8251 16.4981L22.6954 17.0648C22.6452 17.0785 22.5949 17.1105 22.5675 17.1562L20.8491 19.7338L19.2861 18.1708C20.0311 17.2476 20.4698 16.0731 20.4698 14.798C20.4698 14.7112 20.4698 14.6198 20.4607 14.533L22.9422 14.4461C23.0108 14.4416 23.0748 14.4096 23.1159 14.3547C23.157 14.2999 23.1753 14.2313 23.157 14.1628L22.7731 12.5312L24.8663 13.0614Z" fill="white"/>
        <path d="M19.976 8.63298L18.2074 10.4016C17.3207 9.76637 16.2376 9.39162 15.0631 9.39162C14.9351 9.39162 14.8072 9.39619 14.6792 9.4099V6.65869C14.6792 6.59014 14.6472 6.52159 14.597 6.48045C14.5421 6.43932 14.4736 6.42104 14.405 6.43475L12.7598 6.7638L13.3036 4.61584L16.7449 4.65698L17.307 6.78208C17.3207 6.83692 17.3527 6.88263 17.403 6.91462L19.976 8.63298Z" fill="white"/>
        <path d="M9.21345 21.0317L10.5159 21.8406L8.57363 22.9969L6.17432 20.5381L7.27572 18.6324C7.30314 18.5867 7.31228 18.5318 7.30314 18.477L6.69531 15.4379H9.69788C9.83499 16.6352 10.3651 17.7138 11.1649 18.541L9.16318 20.6844C9.11748 20.7301 9.09463 20.7986 9.10377 20.8672C9.11291 20.9357 9.15404 20.9951 9.21345 21.0317Z" fill="#00CCCC"/>
        <path d="M23.1295 20.4651L20.7119 22.9101L18.7879 21.8361C18.7559 21.8178 18.7193 21.8087 18.6782 21.8087C18.6645 21.8087 18.6462 21.8087 18.6325 21.8132L15.607 22.4713L15.5659 20.1817C16.9095 20.0583 18.1115 19.4414 18.9844 18.5182L20.721 20.2548C20.7667 20.296 20.8216 20.3188 20.8855 20.3188H20.9038C20.9724 20.3142 21.0364 20.2777 21.0729 20.2183L22.0601 18.7376L23.1295 20.4651Z" fill="#00CCCC"/>
        <path d="M21.9365 10.9865L22.6495 13.9982L20.4193 14.0759C20.241 12.7232 19.5601 11.5258 18.5684 10.6849L20.497 8.75631C20.5472 8.71061 20.5701 8.64206 20.5655 8.57351C20.5564 8.50496 20.5198 8.44554 20.465 8.40441L19.0391 7.4584L20.5107 6.50781L22.9922 8.88428L21.9548 10.822C21.932 10.8723 21.9228 10.9317 21.9365 10.9865Z" fill="#00CCCC"/>
        <path d="M14.2221 6.93743V9.46014C12.819 9.67493 11.5942 10.4336 10.7671 11.5167L8.43172 9.26362C8.39059 9.22249 8.33118 9.19964 8.27634 9.19964H8.24892C8.18037 9.20878 8.12096 9.24534 8.07982 9.30475L7.49942 10.2142L6.66309 8.81118L9.12181 6.41187L11.0276 7.51784C11.0733 7.54526 11.1327 7.5544 11.1875 7.54069L14.2221 6.93743Z" fill="#00CCCC"/>
        </g>
        <defs>
        <clipPath id="clip0_10012_3203">
        <rect width="29.4133" height="32" fill="white"/>
        </clipPath>
        </defs>
      </svg>
      <Box className="Sim-site-name" display={'flex'} alignItems={'center'} color={"#FFFFFF"} ref={ele}>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>勞</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>工</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>安</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>全</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>衛</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>生</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>管</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>理</Typography>
        <Typography className="Sim-site-word" component={'span'} variant={'h4'} color={"#FFFFFF"}>處</Typography>
      </Box>
    </Stack>
  )
};

export default LogoLaborAnimation;
